<template>
    <div class="pa-3" style="height: 100%">
        <div
            :style="heightWrapper"
            id="home-wrapper"
            v-if="loaded && widgetVisible == true"
            style="height: 100%; overflow: hidden; z-index: 999; overscroll-behavior: contain"
            class="d-flex flex-column rounded-lg shadowBox"
        >
            <NoConnection v-if="online === false" />

            <div style="height: 100%" class="d-flex flex-column flex-grow-1" id="content-wrapper">
                <div class="d-flex flex-column flex-grow-1" style="margin-top: auto">
                    <div
                        v-if="config.customer.showProfilesTop && topicHeader == ''"
                        style="
                            z-index: 2;
                            position: relative;
                            top: 30px;
                            width: 100%;
                            margin-left: auto;
                            margin-right: auto;
                        "
                    >
                        <div style="display: flex; justify-content: center">
                            <div v-for="(pic, index) in config.customer.profilePeople" :key="index">
                                <div
                                    v-if="index === 1"
                                    class="small-side-by-side"
                                    style="margin-top: -5px"
                                    :style="{
                                        backgroundImage: `url(${pic})`,
                                        'border-color': 'green'
                                    }"
                                ></div>
                                <div
                                    v-else
                                    class="small-side-by-side"
                                    :style="{
                                        backgroundImage: `url(${pic})`,
                                        'border-color': 'white'
                                    }"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="box d-flex flex-row justify-space-between align-center px-3 rounded-lg rounded-b-0"
                        :style="primaryGradient"
                        style="min-height: 60px; height: 100%"
                    >
                        <div>
                            <div class="color d-flex flex-row align-left" style="float: left; width: 100%">
                                <v-btn
                                    v-if="!main"
                                    icon
                                    small
                                    @click="main = !main"
                                    :color="cnfg.customer.secondaryColorHexHeader"
                                >
                                    <v-icon :color="cnfg.customer.secondaryColorHex">
                                        mdi-arrow-left
                                    </v-icon>
                                </v-btn>
                                <v-btn
                                    disabled
                                    icon
                                    small
                                    v-else
                                    style="opacity: 0"
                                    :color="cnfg.customer.secondaryColorHexHeader"
                                >
                                    <v-icon :color="cnfg.customer.secondaryColorHex">
                                        mdi-arrow-left
                                    </v-icon>
                                </v-btn>
                            </div>
                        </div>
                        <span
                            class="text-center"
                            style="font-size: 18px; font-weight: 500"
                            v-if="!config.customer.showCustomerNameInHeader"
                        >
                            {{ item.name }}
                        </span>

                        <!-- Top Heading -->
                        <span
                            class="text-center"
                            :style="primaryStyleColor"
                            style="
                                font-size: 18px;
                                font-weight: 500;
                                position: absolute;
                                margin-left: auto;
                                margin-right: auto;
                                left: 0;
                                right: 0;
                                max-width: 250px;
                            "
                            v-else
                        >
                            <transition name="shift" mode="out-in">
                                <div :key="topicHeader" :style="{ color: cnfg.customer.secondaryColorHexHeader }">
                                    <div
                                        v-if="cnfg.customer.showLogoHeader && main"
                                        class="d-flex flex-row align-center"
                                    >
                                        <img
                                            :src="require('@/assets/logos/' + cnfg.customer.companyLogo)"
                                            :style="{ height: cnfg.customer.companyLogoHeight }"
                                        />
                                    </div>
                                    <div v-else>{{ topicHeader }}</div>
                                </div>
                            </transition>
                        </span>
                        <div>
                            <v-btn
                                @click="hideWidget()"
                                style="z-index: 9999"
                                icon
                                small
                                class="ml-1"
                                :color="cnfg.customer.secondaryColorHexHeader"
                            >
                                <v-icon :color="cnfg.customer.secondaryColorHex">mdi-minus</v-icon>
                            </v-btn>

                            <v-btn
                                v-if="showType == 'chat' && !main"
                                @click="closeChat()"
                                style="z-index: 9999"
                                icon
                                small
                                class="ml-1"
                                :disabled="!chatClosedByUser"
                                :color="cnfg.customer.secondaryColorHexHeader"
                            >
                                <v-icon :color="cnfg.customer.secondaryColorHex">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>

                    <div
                        v-if="0 === 0 && main"
                        style=""
                        class="d-flex flex-column flex-grow-1 pa-5 containerFull justify-space-between"
                    >
                        <div
                            style="display: flex; justify-content: center; margin-top: 10px"
                            v-if="config.customer.showProfilePictures"
                        >
                            <div
                                class="small-side-by-side"
                                v-for="(pic, index) in groupFullUserData"
                                :key="index"
                                :style="{
                                    backgroundImage: `url(${pic.profileImageUrl})`,
                                    'border-color': setBorderColor(`${pic.presence.availability}`)
                                }"
                            ></div>
                        </div>

                        <div
                            style="font-size: 16px; width: 100%; height: 100%; margin-top: 10px; margin-bottom: 10px"
                            v-if="true"
                        >
                            <div
                                id="profilePictures"
                                class="d-flex flex-row justify-space-between mb-8"
                                v-if="config.customer.showProfilePictures"
                            >
                                <v-avatar v-for="item in config.customer.profilePeople" :key="item">
                                    <img :src="item" alt="Avatar" style="border: 0px solid #ccc" class="shadowBox" />
                                </v-avatar>
                            </div>

                            <div style="display: flex; justify-content: center" class="d-flex flex-column pt-0 pb-3">
                                <v-sheet
                                    class="d-flex flex-column rounded-lg pa-4 pt-6 softShadow agentBox"
                                    style="border: 0"
                                    outlined
                                >
                                    <h4 class="d-flex flex-row mb-6 mt-2 justify-center">
                                        {{ config.customer.heading }}
                                    </h4>
                                    <v-divider />
                                    <div class="d-flex flex-column mt-3">
                                        <v-card
                                            outlined
                                            elevation="0"
                                            class="pa-3 my-1 d-flex flex-row justify-space-between align-center v-card-hover"
                                            @click="show('taxi')"
                                            style="min-height: 68px"
                                            v-if="config.customer.showBooking"
                                        >
                                            <div>
                                                <v-icon :color="primaryColor" size="20">mdi-taxi</v-icon>
                                                <span class="ml-5">Bokning</span>
                                            </div>

                                            <div style="max-width: 150px; text-align: right; line-height: 1.2em">
                                                <span
                                                    style="font-size: 12px"
                                                    v-dompurify-html="config.customer.descriptionText.taxi"
                                                ></span>
                                            </div>
                                        </v-card>

                                        <v-card
                                            outlined
                                            elevation="0"
                                            class="pa-3 my-1 d-flex flex-row justify-space-between align-center v-card-hover"
                                            @click="show('chat')"
                                            style="min-height: 68px"
                                            v-if="config.customer.showChat"
                                        >
                                            <div>
                                                <v-icon :color="primaryColor" size="20">mdi-chat</v-icon>
                                                <span class="ml-5">Chatt</span>
                                            </div>

                                            <div style="max-width: 150px; text-align: right; line-height: 1.2em">
                                                <span v-if="openChat" style="font-size: 12px">
                                                    <span
                                                        v-dompurify-html="
                                                            config.customer.descriptionText.chatOpen || 'Chatta med oss'
                                                        "
                                                        style="font-size: 12px"
                                                    ></span>
                                                </span>
                                                <span style="color: red" v-else>
                                                    <span
                                                        v-dompurify-html="chatClosed || 'Chatten är stängd'"
                                                        style="font-size: 12px"
                                                    ></span>
                                                    <div
                                                        v-if="extraClosedMessage"
                                                        v-dompurify-html="extraClosedMessage"
                                                        style="font-size: 12px"
                                                    ></div>
                                                </span>
                                            </div>
                                        </v-card>

                                        <v-card
                                            outlined
                                            elevation="0"
                                            class="pa-3 my-1 d-flex flex-row justify-space-between align-center v-card-hover"
                                            @click="show('faq')"
                                            style="min-height: 68px"
                                            v-if="config.customer.showFaq"
                                        >
                                            <div>
                                                <v-icon :color="primaryColor" size="20">mdi-file-find</v-icon>
                                                <span class="ml-5">FAQ</span>
                                            </div>

                                            <div style="max-width: 150px; text-align: right; line-height: 1.2em">
                                                <span style="font-size: 12px">Enkla frågor & svar</span>
                                            </div>
                                        </v-card>

                                        <v-card
                                            outlined
                                            elevation="0"
                                            class="pa-3 my-1 d-flex flex-row justify-space-between align-center v-card-hover"
                                            @click="show('phone')"
                                            style="min-height: 68px"
                                            v-if="config.customer.showPhone"
                                        >
                                            <div>
                                                <v-icon :color="primaryColor" size="20">mdi-phone</v-icon>
                                                <span class="ml-5">Telefon</span>
                                            </div>

                                            <div style="max-width: 150px; text-align: right; line-height: 1.2em">
                                                <span
                                                    style="font-size: 12px"
                                                    v-dompurify-html="
                                                        config.customer.descriptionText.telephone ||
                                                        config.customer.phoneText
                                                    "
                                                ></span>
                                            </div>
                                        </v-card>

                                        <v-card
                                            outlined
                                            elevation="0"
                                            class="pa-3 my-1 d-flex flex-row justify-space-between align-center v-card-hover"
                                            @click="show('phoneSimple')"
                                            style="min-height: 68px"
                                            v-if="config.customer.showPhoneSimple"
                                        >
                                            <div>
                                                <v-icon :color="primaryColor" size="20">mdi-phone</v-icon>
                                                <span class="ml-5">Telefon</span>
                                            </div>

                                            <div style="max-width: 150px; text-align: right; line-height: 1.2em">
                                                <span
                                                    style="font-size: 12px"
                                                    v-dompurify-html="
                                                        config.customer.descriptionText.telephone ||
                                                        config.customer.phoneText
                                                    "
                                                ></span>
                                            </div>
                                        </v-card>

                                        <v-card
                                            outlined
                                            elevation="0"
                                            class="pa-3 my-1 d-flex flex-row justify-space-between align-center v-card-hover"
                                            @click="show('mail')"
                                            style="min-height: 68px"
                                            v-if="config.customer.showMail"
                                        >
                                            <div>
                                                <v-icon :color="primaryColor" size="20">mdi-email</v-icon>
                                                <span class="ml-5">E-post</span>
                                            </div>
                                            <div style="max-width: 150px; text-align: right; line-height: 1.2em">
                                                <span style="font-size: 12px">
                                                    {{ config.customer.descriptionText.mail || 'Skicka-epost' }}
                                                </span>
                                            </div>
                                        </v-card>
                                    </div>
                                </v-sheet>
                            </div>
                        </div>

                        <div v-else style="display: flex; justify-content: center" class="d-flex flex-column pt-0 pb-3">
                            <v-sheet
                                class="d-flex flex-column rounded-lg pa-4 pt-6 softShadow agentBox"
                                style="border: 0"
                                outlined
                            >
                                <h4 class="d-flex flex-row mb-6 mt-2 justify-center">
                                    {{ config.customer.heading }}
                                </h4>

                                <v-divider />
                                <div class="d-flex flex-column mt-3">
                                    <v-card
                                        outlined
                                        elevation="0"
                                        class="pa-3 my-1 d-flex flex-row justify-space-between align-center v-card-hover"
                                        @click="show('chat')"
                                    >
                                        <div>
                                            <v-icon :color="primaryColor" size="20">mdi-chat</v-icon>
                                            <span class="ml-5">Chatt</span>
                                        </div>

                                        <div style="max-width: 150px; text-align: right; line-height: 1.2em">
                                            <span v-if="openChat" style="font-size: 12px">
                                                <span
                                                    v-dompurify-html="
                                                        config.customer.descriptionText.chatOpen || 'Chatta med oss'
                                                    "
                                                    style="font-size: 12px"
                                                ></span>
                                            </span>
                                            <span style="color: red" v-else>
                                                <span
                                                    v-dompurify-html="chatClosed || 'Chatten är stängd'"
                                                    style="font-size: 12px"
                                                ></span>
                                            </span>
                                        </div>
                                    </v-card>

                                    <v-card
                                        outlined
                                        elevation="0"
                                        class="pa-3 my-1 d-flex flex-row justify-space-between align-center v-card-hover"
                                        @click="show('phone')"
                                    >
                                        <div>
                                            <v-icon :color="primaryColor" size="20">mdi-phone</v-icon>
                                            <span class="ml-5">Telefon</span>
                                        </div>
                                        <div style="max-width: 150px; text-align: right; line-height: 1.2em">
                                            <span
                                                style="font-size: 12px"
                                                v-dompurify-html="
                                                    config.customer.descriptionText.telephone ||
                                                    config.customer.phoneText
                                                "
                                            ></span>
                                        </div>
                                    </v-card>

                                    <v-card
                                        outlined
                                        elevation="0"
                                        class="pa-3 my-1 d-flex flex-row justify-space-between align-center v-card-hover"
                                        @click="show('mail')"
                                        v-if="config.customer.showMail"
                                    >
                                        <div>
                                            <v-icon :color="primaryColor" size="20">mdi-email</v-icon>
                                            <span class="ml-5">E-post</span>
                                        </div>
                                        <div style="max-width: 150px; text-align: right; line-height: 1.2em">
                                            <span style="font-size: 12px">
                                                {{ config.customer.descriptionText.mail || 'Skicka-epost' }}
                                            </span>
                                        </div>
                                    </v-card>
                                </div>
                            </v-sheet>
                        </div>

                        <div class="d-flex flex-column align-center pt-3 pb-0">
                            <img :src="config.logo" style="height: 35px" class="d-flex flex-column" />
                            <div style="width: 100%" class="d-flex flex-column mt-3">
                                <span style="font-size: 12px">
                                    Powered by
                                    <a
                                        href="https://www.customerfirst.se"
                                        style="color: #2cb5a3; text-decoration: none"
                                        target="blank"
                                    >
                                        Customer First
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="!main"
                    class="inside-wrapper pa-0 pt-0 d-flex flex-column rounded-lg rounded-t-0"
                    style="overflow-x: hidden"
                >
                    <div class="flex-column inside-wrapper px-0">
                        <Chat
                            :user="user"
                            :primaryColor="config.customer.primaryColor"
                            :secondaryColor="config.customer.secondaryColor"
                            :primaryGradient="config.customer.primaryGradient"
                            v-if="showType == 'chat'"
                            ref="chat"
                            :openChat="openChat"
                            @chatClosed="chatClosedByUser = true"
                            @chatOpened="chatClosedByUser = false"
                            :suggestion="suggestionList"
                        />
                        <Mail :user="user" v-if="showType == 'mail'" />
                        <Phone
                            :config="config"
                            :recipient="config.customer.relationId"
                            :primaryColor="config.customer.primaryColor"
                            :secondaryColor="config.customer.secondaryColor"
                            :primaryGradient="config.customer.primaryGradient"
                            v-if="showType == 'phone'"
                        />

                        <PhoneSimple
                            :config="config"
                            :recipient="config.customer.relationId"
                            :primaryColor="config.customer.primaryColor"
                            :secondaryColor="config.customer.secondaryColor"
                            :primaryGradient="config.customer.primaryGradient"
                            v-if="showType == 'phoneSimple'"
                        />

                        <Faq :user="user" v-if="showType == 'faq'" />
                        <Book :user="user" v-if="showType == 'taxi'" />
                    </div>
                </div>
            </div>
        </div>

        <div
            class="speechBubbleNew softShadow rounded-lg py-2 px-3 rounded-br-0"
            style="cursor: pointer; width: 100%"
            :style="{ backgroundColor: cnfg.customer.secondaryColorHex }"
            @click="showWidget()"
            v-if="speechBubble.active === true"
        >
            {{ speechBubble.text }}
        </div>
        <transition name="animationLeave">
            <div
                :style="{ backgroundColor: cnfg.customer.secondaryColorHex }"
                @click="showWidget()"
                v-if="widgetVisible == false"
                class="softShadow d-flex flex-column justify-center callToAction"
                style="height: 70px; width: 70px; border-radius: 35px; position: absolute; z-index: 0"
                id="callToAction"
            >
                <v-icon
                    :class="cnfg.customer.enableJumpAnimation ? 'jumpAnimation' : ''"
                    style="color: white"
                    size="30"
                >
                    mdi-chat
                </v-icon>
            </div>
        </transition>

        <!--
      <div v-if="widgetVisible == false" class="icon"  @click="showWidget()">

          <i style="padding-top:20px; color:black;" class="material-icons">{{ whois[0] }}</i>

      </div>
      -->
    </div>
</template>

<script>
    import NoConnection from './Small/NoConnection';
    import presenceColor from '@/plugins/presence';
    import Phone from './Phone';
    import PhoneSimple from './PhoneSimple';
    import Mail from './Mail';
    import Faq from './Faq';
    import Book from './Book';
    import TextAnim from './Small/TextAnim';
    import config from '../api/config';

    export default {
        data() {
            return {
                vcoConfig: {
                    handler: this.handler,
                    middleware: this.middleware,
                    events: ['dblclick', 'click'],
                    // Note: The default value is true, but in case you want to activate / deactivate
                    //       this directive dynamically use this attribute.
                    isActive: true,
                    // Note: The default value is true. See "Detecting Iframe Clicks" section
                    //       to understand why this behavior is behind a flag.
                    detectIFrame: true,
                    // Note: The default value is false. Sets the capture option for EventTarget addEventListener method.
                    //       Could be useful if some event's handler calls stopPropagation method preventing event bubbling.
                    capture: false
                },
                suggestionList: [],
                cnfg: config,
                primaryGradient: {
                    background: config.customer.primaryGradient,
                    color: config.customer.secondaryColor
                },
                primaryStyle: {
                    background: config.customer.primaryColor,
                    color: config.customer.secondaryColor
                },
                primaryStyleHex: {
                    background: config.customer.primaryColorHex,
                    color: config.customer.secondaryColor
                },
                primaryStyleColor: {
                    color: config.customer.secondaryColor
                },
                primaryColor: config.customer.primaryColor,
                showBackArrow: true,
                whois: config.customer.iconToggle,
                topicHeader: '',
                groupInfo: [],
                slaSocialMedia: 1,
                slaMail: 8,
                groups: [],
                dialogCase: false,
                groupFullUserData: [],
                extraClosedMessage: '',
                groupMember: [],
                loading: false,
                main: true,
                widgetVisible: false,
                showType: 0,
                user: [],
                loaded: false,
                config: Object,
                heightWrapper: '',
                interVal: '',
                openChat: true,
                chatClosedByUser: true,
                primaryColor: config.customer.primaryColor,
                speechBubble: {
                    active: false,
                    text: 'Behöver du hjälp? Starta chatt här'
                },
                online: true
            };
        },
        components: {
            Phone,
            PhoneSimple,
            Mail,
            Chat: () => import('./Chat'),
            Faq,
            Book,
            TextAnim,
            NoConnection
        },
        computed: {
            goBack() {
                return this.$store.state.goBack;
            }
        },
        destroyed() {
            clearInterval(this.interVal);
        },
        beforeDestroy() {
            window.removeEventListener('online', this.updateOnlineStatus);
            window.removeEventListener('offline', this.updateOnlineStatus);
        },
        watch: {
            goBack(val) {
                this.main = true;
                this.widgetVisible = true;
                this.showType = 0;
                this.checkIfChatIsOpen();
            },
            main(val) {
                if (val == true) {
                    this.setTopics();
                    parent.postMessage('normalize', '*');
                }
            }
        },
        created() {
            this.setTopics();
            this.config = config;
            this.loaded = true;

            // If there is a active chat go to chat.
            if (localStorage.getItem('rand') == null || localStorage.getItem('rand') == 'null') {
            } else {
                //removed this, as suggested as change when reloading page.
                this.show('chat');
            }
        },
        mounted() {
            window.addEventListener('online', this.updateOnlineStatus);
            window.addEventListener('offline', this.updateOnlineStatus);

            window.addEventListener('message', ({ data }) => {
                this.handlePostMessage(data);
            });
            if (config.customer.autostartChat) {
                this.main = false;
                this.showType = 'chat';
                this.showBackArrow = false;
            }
            this.toogleIcons();
            const showWidget = localStorage.getItem('show');
            if (showWidget != null) {
                this.widgetVisible = JSON.parse(showWidget);
                if (!this.widgetVisible) {
                    window.top.postMessage('hideWidget', '*');
                } else {
                    window.top.postMessage('showWidget', '*');
                }
            }
            const id = 0;
            parent.postMessage({ show: this.widgetVisible }, '*');

            if (localStorage.getItem('visitorInfo') === null) {
            } else {
                parent.postMessage(id, '*');
            }
            if (this.widgetVisible) this.checkIfChatIsOpen();
        },
        sockets: {
            connect: function () {
                this.checkIfChatIsOpen();
            }
        },
        methods: {
            updateOnlineStatus(state) {
                if (state?.type === 'offline') {
                    this.openChat = false;
                    this.online = false;
                } else {
                    this.checkIfChatIsOpen();
                    this.online = true;
                }
            },
            checkIfChatIsOpen() {
                this.$store.dispatch('checkAvailability', this.config.customer.relationId).then((data) => {
                    this.setChatState(data);
                });
            },
            closeChat() {
                this.$refs.chat.closeChat();
            },
            handlePostMessage(data) {
                if (data.command == 'openWidget') {
                    this.showWidget();
                }
                if (data.command == 'closeWidget') {
                    this.hideWidget();
                }
                if (data.command == 'sendBubble') {
                    this.speechBubble.active = true;
                    this.speechBubble.text = data.message;
                }
                if (data.command == 'closeBubble') {
                    this.speechBubble.active = false;
                    this.speechBubble.text = '';
                }
            },
            setChatState(data) {
                if (!data) {
                    this.chatClosed = 'Chatten är stängd';
                    this.openChat = false;
                    return;
                }
                if (data.extraClosed) {
                    this.extraClosedMessage =
                        data.extraClosed.closedReason +
                        ' ' +
                        data.extraClosed.start.text +
                        '-' +
                        data.extraClosed.end.text;
                    this.openChat = false;
                }
                if (data.isChatOpen?.isChatOpen && !data.extraClosed) {
                    if (data.isAgentsAvailable === false) {
                        this.chatClosed = 'Inga agenter online just nu. Prova igen senare';
                        this.openChat = false;
                        return;
                    }

                    this.openChat = data.isChatOpen.isChatOpen;
                } else {
                    if (data.isChatOpen?.start) {
                        this.chatClosed = `Öppettider ${data.isChatOpen.start?.text}-${data.isChatOpen.end?.text}`;
                    } else {
                        this.chatClosed = 'Chatten är stängd';
                    }
                    if (!data.extraClosed) {
                        this.openChat =
                            typeof data.isChatOpen === 'boolean' ? data.isChatOpen : data.isChatOpen.isChatOpen;
                    }

                    return;
                }
                if (data.suggestion) {
                    this.suggestionList = data.suggestion;
                } else {
                    this.suggestionList = [
                        { keyword: 'Q11', question: 'A1', short: 'S1' },
                        { keyword: 'Q22', question: 'A2', short: 'S2' }
                    ];
                }
            },
            toogleIcons() {
                this.interVal = window.setInterval(() => {
                    this.pollIcon();
                }, 5000);
            },
            pollIcon() {
                const first = this.whois.shift();
                this.whois = this.whois.concat(first);
            },
            hideWidget() {
                this.toogleIcons();
                this.widgetVisible = false;
                parent.postMessage({ show: false }, '*');
                localStorage.setItem('show', false);
                window.top.postMessage('hideWidget', '*');
            },
            showWidget() {
                this.checkIfChatIsOpen();
                this.speechBubble.active = false;
                clearInterval(this.interVal);
                parent.postMessage({ show: true }, '*');
                this.widgetVisible = true;
                localStorage.setItem('show', true);
                window.top.postMessage('showWidget', '*');
            },
            setTopics(type) {
                switch (type) {
                    case 'phone':
                        this.topicHeader = 'Telefon';
                        break;
                    case 'phoneSimple':
                        this.topicHeader = 'Telefon';
                        break;
                    case 'chat':
                        this.topicHeader = 'Chatt';
                        break;
                    case 'mail':
                        this.topicHeader = 'Skicka mejl';
                        break;
                    case 'faq':
                        this.topicHeader = 'Frågor & Svar';
                        break;
                    case 'taxi':
                        this.topicHeader = 'Boka taxi';
                        break;

                    default:
                        this.topicHeader = config.customer.companyName;
                        break;
                }
            },
            show(type) {
                if (type == 'chat' && this.openChat === false) {
                    return;
                }

                if (type == 'mail' && config.customer.mailToLink === true) {
                    window.open('mailto:' + config.customer.mailToMailtoLink, '_blank');
                    return;
                }

                this.setTopics(type);

                this.showType = type;
                this.main = !this.main;
                if (this.showType == 'taxi') {
                    this.heightWrapper = '700px !important';
                    parent.postMessage('bookingWidget', '*');
                }
            },
            setBorderColor(presenceId) {
                return presenceColor.setPresenceColor(presenceId);
            }
        }
    };
</script>

<!-- default lbue 471FCD -->
<style lang="scss">
    .shift-enter-active {
        transition: all 0.3s ease;
    }
    .shift-leave-active {
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .shift-enter
/* .slide-fade-leave-active for <2.1.8 */ {
        transform: translateY(10px);
        opacity: 0;
    }

    .shift-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
        transform: translateY(-10px);
        opacity: 0;
    }

    $primary: red;
    $colorForBouncer: rgb(255, 209, 67);

    .v-card-hover {
        transition: background-color 0.3s;
    }

    .v-card-hover:hover {
        background-color: #eee;
        transition: background-color 0.3s;
    }

    .agentBox {
        animation: append-animate 0.3s linear;
    }

    @keyframes append-animate {
        from {
            transform: scale(0.8);
            opacity: 0.8;
        }
        to {
            transform: scale(1);
            opacity: 1;
        }
    }

    #content-wrapper {
        animation: animate-up-content 0.6s cubic-bezier(1, 0.5, 0.8, 1);
        position: relative;
        overflow: hidden;
    }

    #home-wrapper {
        animation: animate-up 0.6s cubic-bezier(1, 0.5, 0.8, 1);
        position: relative;
    }

    .animationLeave-enter-active {
        animation: animate-up-call 0.5s;
    }

    .animationLeave-before-enter {
        opacity: 0;
    }

    #callToAction {
        bottom: 15px;
        right: 15px;
    }

    #callToAction:hover {
        cursor: pointer;
    }

    .jumpAnimation {
        animation: animate-jump 5s infinite ease;
        position: relative;
    }

    @keyframes animate-jump {
        0% {
            bottom: 0;
        }

        90% {
            bottom: 0px;
        }

        92% {
            bottom: 5px;
        }

        94% {
            bottom: 0px;
        }

        96% {
            bottom: 5px;
        }

        98% {
            bottom: 0px;
        }

        100% {
            bottom: 0px;
        }
    }

    @keyframes animate-up-call {
        0% {
            bottom: -100px;
            opacity: 0;
        }

        100% {
            bottom: 15px;
            opacity: 1;
        }
    }

    @keyframes animate-up-content {
        0% {
            opacity: 0;
        }

        55% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-up {
        0% {
            opacity: 0;
            max-height: 0%;
            max-width: 0%;
            bottom: -100%;
            right: -100%;
        }

        55% {
            opacity: 1;
            max-height: 100%;
            max-width: 100%;
            bottom: 0%;
            right: 0;
        }
    }

    .chatBoxUser {
        // color: black !important;
        animation: append-animate 0.3s linear;
        font-size: 12px;
        text-align: left;
        display: inline-block;
        font-size: 14px;
        line-height: 1.2em;
        border-top-left-radius: 15px !important;
        border-top-right-radius: 0px !important;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;
        white-space: -moz-pre-wrap;
        white-space: pre-wrap;
        max-width: 100%;
        word-wrap: break-word !important;
    }

    .chatBoxClient {
        animation: append-animate 0.3s linear;
        background-color: rgb(255, 255, 255);
        font-size: 12px;
        max-width: 70vw;
        color: black !important;
        text-align: left;
        display: inline-block;
        font-size: 14px;
        line-height: 1.2em;
        border-top-left-radius: 0px !important;
        border-top-right-radius: 15px !important;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;
        white-space: -moz-pre-wrap;
        white-space: pre-wrap;
        word-wrap: break-word !important;
    }

    .chatSuggestion {
        background-color: rgb(245, 245, 245);
        color: black;
        text-align: left;
        display: inline-block;
        font-size: 14px;
        line-height: 1.2em;
        border-top-left-radius: 15px !important;
        border-top-right-radius: 15px !important;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;
        white-space: -moz-pre-wrap;
        white-space: pre-wrap;
    }

    .containerFull {
        background-color: rgb(245, 245, 245);
    }

    input[type='text'] {
        font-size: 12px !important;
    }

    :deep .v-label {
        font-size: 12px !important;
    }
    :deep .v-label--active {
        font-size: 12px !important;
        font-weight: bold;
    }

    .shadowBox {
        box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.2), 0 1.5px 5px 0 rgba(0, 0, 0, 0);
    }

    .speechBubbleNew {
        z-index: 9999;
        font-size: 12px;
        position: relative;
        bottom: 12px;
        text-align: left;
    }

    .speechBubble:after {
        border-top-color: #ffffff;
        border: 1em solid transparent;
        content: '';
        margin-left: -1em;
        position: absolute;
        top: 100%;
        left: 50%;
        width: 0;
        height: 0;
    }

    .speech-bubble {
        z-index: 9999;
        background: #ffd143;
        color: black;
        display: inline-block;
        font-size: 12px;
        margin-bottom: 4em;
        padding: 6px;
        position: relative;
        bottom: 5px;
        text-align: center;
        vertical-align: top;
        min-width: 8.7em;
        border-radius: 3px;
        -webkit-box-shadow: 0px 0px 5px 1px #b0a5a5;
        box-shadow: 0px 0px 5px 1px #b0a5a5;
    }
    .speech-bubble:after {
        border: 1em solid transparent;
        border-top-color: #ffd143;
        content: '';
        margin-left: -1em;
        position: absolute;
        top: 100%;
        left: 50%;
        width: 0;
        height: 0;
    }

    .container-widget-text {
        float: right;
        margin-right: 10%;
        width: 100px;
    }

    .text-color {
        color: black;
    }

    .padding-shadow {
        padding: 5px;
    }

    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
        .padding-shadow {
            padding: 0px !important;
        }
    }

    .inside-wrapper {
        width: 100%;
        height: 100%;
        background-color: white;
        overflow-y: auto;
        @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
            width: 100%;
        }
    }

    .wait-box {
        float: right;
        width: 70px !important;
        margin-right: -10px;
        @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
            width: 80px;
            margin-right: 20px;
        }
    }
    .icons-left {
        float: left;
        width: 30px;
        height: 30px;
        margin-top: -10px;
        margin-left: 65px;
        padding: 15px;
        @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
            margin-left: 50px;
        }
    }

    .icon {
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 4rem;
        height: 4rem;
        border-radius: 50%;

        cursor: pointer;
        -webkit-transition: -webkit-transform 0.8s ease-in-out;
        transition: transform 0.8s ease-in-out;
        animation: ripple 0.7s linear infinite;
    }

    .icon:hover {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);

        opacity: 0.9;
    }

    @keyframes ripple {
        0% {
            box-shadow: 0 0 0 0 rgba($colorForBouncer, 0.3), 0 0 0 0.25em rgba($colorForBouncer, 0.3),
                0 0 0 0.75em rgba($colorForBouncer, 0.3);
        }
        100% {
            box-shadow: 0 0 0 0.25em rgba($colorForBouncer, 0.3), 0 0 0 0.75em rgba($colorForBouncer, 0.3);
        }
    }

    .color {
        color: $primary;
    }

    .spin {
        border-radius: 50%;
        -webkit-transition: -webkit-transform 0.8s ease-in-out;
        transition: transform 0.8s ease-in-out;
    }
    .spin:hover {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
        background-color: $primary;
        opacity: 0.9;
    }

    .hover {
        -webkit-transition: -webkit-transform 0.8s ease-in-out;
        transition: transform 0.8s ease-in-out;
    }

    .hover:hover {
        opacity: 0.6;
    }
    .p {
        animation-duration: 600ms;
        animation-name: slidein;
    }

    @keyframes slidein {
        from {
            right: -400;
        }

        75% {
            right: -150px;
        }

        to {
            right: 90px;
        }
    }

    .home {
        position: fixed;
        width: 21rem;
        min-height: 420px;
        //overflow:hidden !important;
        background-color: white;
        box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.2), 0 1.5px 5px 0 rgba(0, 0, 0, 0.19);
        border-radius: 0px;
    }

    @media screen and (min-width: 340px) and (max-width: 480px) {
        .home {
            width: 100%;
            height: 100vh;
            border-radius: 0px;
            position: initial;
            top: 0;
            left: 0;
            display: inline-block;
            vertical-align: middle;
            margin-bottom: 0px;
            overflow: hidden !important;
        }
    }

    .incr {
        margin: 0%;
    }

    .boxes {
        display: flex;
        flex-direction: column;
    }

    .softShadow {
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.02), 0 2px 2px rgba(0, 0, 0, 0.02), 0 4px 4px rgba(0, 0, 0, 0.02),
            0 8px 8px rgba(0, 0, 0, 0.02), 0 16px 16px rgba(0, 0, 0, 0.01), 0 24px 24px rgba(0, 0, 0, 0.01);
    }

    .box {
        flex: 1;
        width: 100%;
        height: 3.4rem;
        max-height: 3.4rem;
        flex-basis: auto;
        background-color: #7479f2;
        height: 60px;
        border-radius: 0px 0px 0px 0px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1.5px 5px 0 rgba(0, 0, 0, 0.19);
        font-size: 1.25rem;
        color: white;
        //background-image: url("../assets/illustrations/tech_black.png");
        background-size: 90%;
        font-weight: bolder;
        opacity: 1;

        @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
            border-radius: 0px 0px 0px 0px;
            overflow: hidden;
        }
    }
    ._2 {
        background-color: #7479f2;
        background-position: 40% 55%;
        height: 3rem;
        padding-top: 0.8rem;
    }
    ._1 {
        background-color: #471fcd;
        background-position: 40% 20%;
        height: 3rem;
        padding-top: 0.8rem;
    }
    ._0 {
        background-color: $primary;
        background-position: -50% 90%;

        cursor: default;
    }

    .small-side-by-side {
        width: 60px;
        height: 60px;
        flex: none;
        float: left;
        border-radius: 100%;
        background-size: 110%;
        flex-basis: auto;
        margin-left: 5px;
        border: 1.5px solid grey;
        margin: -2px;
        @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
            width: 50px;
            height: 50px;
        }
    }

    #profileTop {
        @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
            top: -30px !important;
        }
    }

    .softShadow {
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.02), 0 2px 2px rgba(0, 0, 0, 0.02), 0 4px 4px rgba(0, 0, 0, 0.02),
            0 8px 8px rgba(0, 0, 0, 0.02), 0 16px 16px rgba(0, 0, 0, 0.01), 0 24px 24px rgba(0, 0, 0, 0.01);
    }
    .bottomSection {
        animation: bottomSectionKey 0.5s ease;
    }
    .bottomSectionOut {
        animation: bottomSectionKey-out 0.5s ease;
    }

    .paddingRight {
        padding-right: 5px !important;
    }

    @keyframes bottomSectionKey {
        0% {
            height: 40px;
        }
        1% {
            height: 40px;
        }
        100% {
            height: 90px;
        }
    }

    .agentBox {
        animation: append-animate 0.3s linear;
    }

    @keyframes append-animate {
        from {
            transform: scale(0.8);
            opacity: 0.8;
        }
        to {
            transform: scale(1);
            opacity: 1;
        }
    }

    .profileInformation {
        animation: fadeInFromNone 0.3s linear;
    }

    .helpText {
        animation: append-animate 0.3s linear;
    }

    .errorBox {
        animation: fadeInFromNone 0.3s linear;
    }

    .v-list-item:hover {
        background-color: rgb(245, 245, 245) !important;
        transition: background-color 0.5s ease;
    }

    @-webkit-keyframes fadeInFromNone {
        0% {
            display: none;
            opacity: 0;
        }

        1% {
            display: block;
            opacity: 0;
        }

        100% {
            display: block;
            opacity: 1;
        }
    }

    .showSuggestions_height {
        min-height: 60px;
    }

    .showSuggestions {
        animation: show-suggestions-animate 0.3s ease-in-out;
    }

    @keyframes show-suggestions-animate {
        from {
            bottom: -50px;
            opacity: 0;
        }
        to {
            bottom: 0px;
            opacity: 1;
        }
    }

    .send-message-textfield {
        white-space: pre-line;
    }
    //acces v-input__slot from .send-message-textfield
    .send-message-textfield .v-input__slot {
        padding: 0px !important;
        box-shadow: none !important;
    }

    pre {
        font-family: inherit;
    }
    .chatWindow {
        overflow-x: hidden;
        width: 100%;
        display: block;
        scroll-behavior: smooth;
    }

    :deep .chatBoxMessage p:last-child {
        margin-bottom: 0px !important;
    }
</style>
